export default __webpack_public_path__ + "static/media/Snd_D_Starts.9b2b1f9e.mp3";